import React from 'react';
import TextField from 'material-ui/TextField';
import { cyan500 } from 'material-ui/styles/colors';
import Checkbox from 'material-ui/Checkbox';
import SelectField from 'material-ui/SelectField';

class Trigger extends React.Component {
  render() {
    const { disableFields, styles, handleTriggerChange, discount, isTrue, handleSelectChange, triggerProducts, triggerItems, triggerMinQty, productsSelect, discounttriggerMinQty, itemsSelect, handleChange  } = this.props
    return(
      <div>
      <h2>Trigger</h2>
        <div className="content">
          <div>
            <ul style={styles.inline}>
              <li>
                <Checkbox
                  label="Any Product"
                  name="triggerByProduct"
                  onCheck={!disableFields ? handleTriggerChange :''}
                  labelStyle={{ marginLeft: '-12px', width: '90px' }}
                  defaultChecked={discount.triggerByProduct}
                />
              </li>
              <li>
                <Checkbox
                  label="All Products"
                  name="triggerAllProducts"
                  onCheck={!disableFields ? handleTriggerChange :''}
                  labelStyle={{ marginLeft: '-12px', width: '90px' }}
                  defaultChecked={discount.triggerAllProducts}
                />
              </li>
            </ul>
            <SelectField
              value={discount.triggerProducts || []}
              multiple={isTrue}
              onChange={!disableFields ? 
              (event, index, value) => handleSelectChange(event, index, value, 'triggerProducts')
              : ''}
              floatingLabelText="Trigger Products"
              style={{ verticalAlign: 'bottom', marginRight: '2%', width: '250px' }}
              name="triggerProducts"
              floatingLabelStyle={styles.floatingLabelStyle}
              errorText={triggerProducts}
              errorStyle={{ color: cyan500 }}
            >
              {productsSelect}
            </SelectField>
          </div>
          <div style={{ clear: 'left' }} />
          <ul style={styles.inline}>
            <li>
              <Checkbox
                label="Any Item"
                name="triggerByItem"
                onCheck={!disableFields ? handleTriggerChange :''}
                labelStyle={{ marginLeft: '-12px', width: '90px' }}
                defaultChecked={discount.triggerByItem}
              />
            </li>
            <li>
              <Checkbox
                label="All Items"
                name="triggerAllItems"
                onCheck={!disableFields ? handleTriggerChange :''}
                labelStyle={{ marginLeft: '-12px', width: '90px' }}
                defaultChecked={discount.triggerAllItems}
              />
            </li>
          </ul>
          <SelectField
            value={discount.triggerItems || []}
            multiple={isTrue}
            onChange={!disableFields ?
              (event, index, value) => handleSelectChange(event, index, value, 'triggerItems')
            : ''}
            floatingLabelText="Trigger Items"
            style={{ display: 'inline-block', verticalAlign: 'bottom', marginRight: '2%', width: '250px' }}
            name="triggerItems"
            floatingLabelStyle={styles.floatingLabelStyle}
            errorText={triggerItems}
            errorStyle={{ color: cyan500 }}
          >
            {itemsSelect}
          </SelectField>
          <br />
          <TextField
            floatingLabelText="Minimum Quantity"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={discounttriggerMinQty || 0}
            name="triggerMinQty"
            onChange={!disableFields ? handleChange : ''}
            style={styles.inputStyle}
            errorText={triggerMinQty}
            errorStyle={{ color: cyan500 }}
          />
          <div style={{ clear: 'left' }} />
        </div>
      </div>
    )
  }
}

export default (Trigger);


// WEBPACK FOOTER //
// ./src/components/discounts/common/Trigger.js